<template>
  <div class="news" v-if="itens.length > 0">
    <carousel :itens="itens"></carousel>
  </div>
</template>

<script>
import Carousel from "./global/Carousel.vue";
import News from "../api/models/News";
import { ref } from "vue";
export default {
  name: "NewsComponent",
  components: { Carousel },
  setup() {
    const itens = ref([]);
    News.highlights().then((response) => {
      itens.value = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.img,
          link: item.links.url,
          description: item.title,
        };
      });
    });
    return { itens };
  },
};
</script>
